// Per-tab request echo. Each mutating request gets a trace id (sent as
// X-Record-Trace-ID); the backend echoes it on the SSE event. isMine() lets the
// EventManager show a toast only in the tab that caused the change, and surface
// "updated by another user" everywhere else. Pure TS; generator is injectable.
export class RequestRegistry {
    private readonly issued = new Set<string>();
    private readonly genId: () => string;

    constructor(genId?: () => string) {
        this.genId = genId ?? defaultGenId;
    }

    issue(): string {
        const id = this.genId();
        this.issued.add(id);
        return id;
    }

    isMine(id: string | null | undefined): boolean {
        return id != null && this.issued.has(id);
    }

    // Mark an echoed id as handled; returns whether it was ours.
    consume(id: string): boolean {
        return this.issued.delete(id);
    }

    clear(): void {
        this.issued.clear();
    }
}

function defaultGenId(): string {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === "function") {
        return c.randomUUID();
    }
    return `req-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
}
